export default __webpack_public_path__ + "static/media/download.22758095.svg";